<template>
    <div :class="['p-card energy-card', { 'energy-card-small': mode === 'small' }]">
      <div class="energy-card-header">
        <span>{{ title }}</span>
        <img src="assets/irinox/icons/ai_info.svg" alt="Irinox AI powered" v-if="tooltip && value!='N/A'" v-tooltip.top="tooltip"/>
        <img src="assets/irinox/icons/ai_info_red.svg" alt="Irinox AI powered" v-if="tooltip && value=='N/A'" v-tooltip.top="tooltip"/>
        <!-- <i v-if="tooltip" :class="['pi pi-info-circle', {'red' : value=='N/A'}]" v-tooltip.top="tooltip"></i> -->
      </div>
      <EnergyOverview v-if="mode==='small'" :title="title" :value="value" :unit="unit" :icon="icon" style="margin-top: 10px;"/>
      <div v-else class="p-d-flex p-jc-between  p-ai-center">
        <div class="energy-card-content">
          <img v-if="icon" :src="icon" :alt="title" />
          <span class="energy-card-content-value">{{ value ?? '-' }}</span>
          <span class="energy-card-content-unit">{{ unit }}</span>
        </div>
        <div v-if="ctaIcon" class="energy-card-cta">
          <img :src="ctaIcon" :alt="ctaAlt" @click="ctaClick" />
        </div>
      </div>
    </div>
</template>

<script>
import EnergyOverview from './EnergyOverview.vue';
export default {
  components: {
    EnergyOverview
  },
  emits: ['click:cta'],
  props: {
    title: String,
    tooltip: String,
    //value può essere sia stringa che numero
    value: String || Number,
    unit: String,
    icon: String,
    ctaIcon: String,
    ctaAlt: String,
    mode: String
  },
  data() {
    return {
    };
  },
  watch: {
  },
  methods: {
    ctaClick() {
      this.$emit('click:cta');
    }
  }
};
</script>

<style scoped></style>